import { RxArrowTopRight } from "react-icons/rx"

const VisaCategoryList = ({ selectedCountry, setSelectedCategory, visaCategories }) => {
  // If visaCategories is empty or undefined, use an empty array
  const categories = visaCategories || [];

  return (
    <div className="flex flex-col md:flex-row flex-wrap gap-4 pt-5">
      {categories.map((category) => (
        <button
          key={category.value || category._id}
          onClick={() => setSelectedCategory(category.value)}
          className="flex items-center justify-between px-6 py-4 bg-white rounded-lg shadow-custom w-full md:w-[40%]"
        >
          <span>{category.label}</span>
          <RxArrowTopRight className="text-gray-900 w-4 md:h-5 h-4 md:w-5" />
        </button>
      ))}
    </div>
  )
}

export default VisaCategoryList

